import React from 'react'
import './App.css';
//20




const HorizontalLine = ({ width, color }) => {
  const lineStyle = {
    width: width || '100%', 
    height: '1px',      
    backgroundColor: color || 'white', 
    margin: '10px 0',      
  };

  return <div style={lineStyle}></div>;
};


function Menu() {
  return (
    
    <div className="origin">
       <title>Menu</title>
       <meta name="description" content="Notre menu"/>
    <div className="gallery-wrapper">
    
  
    <div className="gallery" style={{justifyContent:'center', display:"flex", color:"white", fontFamily:"-moz-initial", fontSize:20, flexDirection:"column", alignItems:"center", width:"100%"}}>
   
     

     {/* MENU */}
     <p style={{ fontFamily:'fantasy',fontSize:22, textAlign:"center"}}>Menu 3 services 48€</p>
     
     <div style={{marginTop:-20, fontFamily:"-moz-initial", fontSize:20, alignItems:'center', justifyContent:"center", display:'flex', flexDirection:"column", maxWidth:"80%", textAlign:"center"}}>
     <p>Mises en bouche</p>
     <HorizontalLine width="20%"  />
     <p>Noix de st jacques bretonnes/couteaux/ potimarron/beurre à l'ail</p>

    <p style={{marginTop:-10, marginBottom:-10}}>OU</p>
     <p>Foie gras d'oie poêlé/ crème de panais/ coing au sirop</p>
      {/*
     <HorizontalLine width="20%"  />

     <p>Foie gras d'oie poêlé aux raisins</p>
     
     <p style={{marginTop:-10, marginBottom:-10}}>OU</p>
     <p>Dos de cabillaud, pommes purée de brocolis beurre aux tomates cerises</p>*/}

     <HorizontalLine width="20%"  />
     <p>Dos de cabillaud/ légumes de saison/ sauce aux girolles</p>
     <p style={{marginTop:-10, marginBottom:-10}}>OU</p>
     <p>Filet de cerf/ chicon braisé/ poire pochée au vin rouge/ sauce poivres kerala</p>

     <HorizontalLine width="20%"  />
     <p>Dessert ou Fromages</p>

     </div>




       {/* MENU */}
     <p style={{ fontFamily:'fantasy',fontSize:22, textAlign:"center"}}>Menu 4 services 68€</p>
      <p style={{ fontFamily:'fantasy',fontSize:18, textAlign:"center"}}>Servi pour l'ensemble de la table</p>
     
     <div style={{marginTop:-20, fontFamily:"-moz-initial", fontSize:20, alignItems:'center', justifyContent:"center", display:'flex', flexDirection:"column", maxWidth:"80%", textAlign:"center"}}>
     <p>Mises en bouche</p>
     <HorizontalLine width="20%"  />
     <p>Noix de st jacques bretonnes/ couteaux/ potimarron/ beurre à l'ail</p>

     <HorizontalLine width="20%"  />
     <p>Foie gras d'oie poêlé/ crème de panais/ coing au sirop</p>
      {/*
   

     <p>Foie gras d'oie poêlé aux raisins</p>
     
     <p style={{marginTop:-10, marginBottom:-10}}>OU</p>
     <p>Dos de cabillaud, pommes purée de brocolis beurre aux tomates cerises</p>*/}

     <HorizontalLine width="20%"  />
     <p>Dos de cabillaud/ légumes de saison/ girolles</p>
     <p style={{marginTop:-10, marginBottom:-10}}>OU</p>
     <p>Filet de cerf/ chicon braisé/ poire pochée au vin rouge/ poivres kerala</p>

     <HorizontalLine width="20%"  />
     <p>Dessert OU Fromages</p>

     </div>




    </div>
    </div>
    </div>
  );
}

export default Menu
